import {fetchEncodedCompanyInfo} from '@/api/company/company';
import * as Sentry from '@sentry/vue';
import {AxiosError} from 'axios';
import {RouteRecordRaw} from 'vue-router';

const routes: RouteRecordRaw[] = [
    {
        path: '/joinEmailConfirm',
        redirect: {
            name: 'RegisterBeforeInvitation',
        },
    },
    {
        path: '/joinEmailConfirm/:encodedInfo',
        name: 'LegacyDistinctLinkInvitation',
        beforeEnter: async (to, from, next) => {
            try {
                const encodedInfo = to.params.encodedInfo as string;
                const data = await fetchEncodedCompanyInfo(encodedInfo);

                next({
                    name: 'DistinctLinkInvitation',
                    query: {ci: data.encCompanyId, cn: data.encCompanyName},
                });
            } catch (err) {
                const axiosError = err as AxiosError;

                console.error(axiosError);

                Sentry.captureException(axiosError, {
                    level: 'error',
                    extra: {
                        code: axiosError.code,
                        status: axiosError.response?.status,
                        request: axiosError.request,
                        response: axiosError.response?.data,
                        message: axiosError.message,
                        from: 'src/router/index.ts > LegacyDistinctLinkInvitation',
                    },
                });

                next(); // NOTE: 레거시 고유 링크 초대 실패 경우
            }
        },
        components: {
            default: () =>
                import('@/views/register/LegacyInvitationFailed.vue'),
        },
    },
    {
        // 회원가입하고자 하는 이메일 입력 & 인증 이메일 발송 step
        path: '/register/beforeInvitation',
        name: 'RegisterBeforeInvitation',
        meta: {
            title: '회원가입 - 이메일 인증',
        },
        components: {
            default: () =>
                import('@/views/register/RegisterBeforeInvitation.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
        },
    },
    {
        // 인증 이메일을 통해 접속 > 회원정보 입력 & 가입 처리 step
        path: '/register/afterInvitation',
        name: 'RegisterAfterInvitation',
        meta: {
            title: '회원가입',
        },
        components: {
            default: () =>
                import('@/views/register/RegisterAfterInvitation.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
        },
    },
    {
        // 개인정보 제 3자 제공 동의 상세 페이지
        path: '/register/terms/thirdParty',
        name: 'ThirdPartyAgreement',
        meta: {
            title: '개인정보 제 3자 제공 동의',
        },
        components: {
            default: () => import('@/views/terms/ThirdPartyAgreement.vue'),
            NavBar: () => import('@/components/common/layout/NavBar.vue'),
        },
    },
    {
        // 회원가입 성공 페이지
        path: '/register/success',
        name: 'RegisterSuccess',
        meta: {
            title: '환영합니다',
        },
        components: {
            default: () => import('@/views/register/RegisterSuccess.vue'),
        },
    },
    {
        // 비즈니스 회원 초대 페이지
        path: '/register/distinctLinkInvitation',
        name: 'DistinctLinkInvitation',
        meta: {
            title: '여기어때 비즈니스 회원으로 초대합니다.',
        },
        components: {
            default: () =>
                import('@/views/register/DistinctLinkInvitation.vue'),
        },
    },
    {
        // 회원가입 성공 페이지 > 여기어때 로그인 버튼 클릭 > 여기어때 앱 다운로드 소개 페이지
        path: '/register/success/download',
        name: 'DownloadAppAfterRegister',
        meta: {
            title: '여기어때 앱 다운로드',
        },
        components: {
            default: () =>
                import('@/views/register/DownloadAppAfterRegister.vue'),
        },
    },
    {
        // 로그인 상태로 회원가입 관련 페이지 진입했을 때 안내 페이지
        path: '/register/requirement/logout',
        name: 'LogoutBeforeRegister',
        meta: {
            title: '로그아웃 후에 이용해주세요',
        },
        components: {
            default: () => import('@/views/register/LogoutBeforeRegister.vue'),
        },
    },
];

export default routes;
